import template from "./inventory-actions.html";
import "./inventory-actions.less";
import { confirmAction } from "./confirmActionPrompt";

import {
	FORM_ENTITY_INVENTORY_ATTEST,
	FORM_ENTITY_INVENTORY_SET,
	FORM_ENTITY_INVENTORY_RESET
} from "routes";
import {
	globs, 
	INVENTORY_OPERATIONS
} from "../../services/globs";
import {
	Action, 
	Any 
} from "../../services/security/actionScopes";

function controller(
	$logger,
	$uibModal, 
	appState,
	api,
	loadingService,
	toastr
) {
	const ctrl = this;

	ctrl.$onInit = () => {
		ctrl.formId = appState.forms.selected.Id;

		ctrl.canAttest = globs
			.entityTypes.byType(ctrl.entity.Type.Code)
			.inventory.byCode(ctrl.inventoryItem.Item.Type.Code)
			.operations.byOperation(INVENTORY_OPERATIONS.attestation)
			.create;

		ctrl.canSet = globs
			.entityTypes.byType(ctrl.entity.Type.Code)
			.inventory.byCode(ctrl.inventoryItem.Item.Type.Code)
			.operations.byOperation(INVENTORY_OPERATIONS.set)
			.create;

		ctrl.canReset = globs
			.entityTypes.byType(ctrl.entity.Type.Code)
			.inventory.byCode(ctrl.inventoryItem.Item.Type.Code)
			.operations.byOperation(INVENTORY_OPERATIONS.reset)
			.create;

		const canAttestAction = new Action(ctrl.canAttest);
		const canSetAction = new Action(ctrl.canSet);
		const canResetAction = new Action(ctrl.canReset);

		ctrl.hasAnyInventoryActionPermission = new Any([canAttestAction, canSetAction, canResetAction]);
	};

	ctrl.attest = () => {
		openQuantityModal("Attest Quantity", FORM_ENTITY_INVENTORY_ATTEST(ctrl.formId, ctrl.entity.Id, ctrl.inventoryItem.Item.Id));
	};

	ctrl.set = () => {
		openQuantityModal("Set Quantity", FORM_ENTITY_INVENTORY_SET(ctrl.formId, ctrl.entity.Id, ctrl.inventoryItem.Item.Id))
			.then(newValue => { ctrl.inventoryItem.Quantity = newValue; });
	};

	ctrl.reset = () => {
		confirmAction(
			"You are about to reset your inventory to zero, are you sure?", 
			() => {
				const apiAction = api.post(FORM_ENTITY_INVENTORY_RESET(ctrl.formId, ctrl.entity.Id, ctrl.inventoryItem.Item.Id), {})
					.then(response => {
						ctrl.inventoryItem.Quantity = response.Value;
						toastr.success("Inventory quantity has been successfully reset");
					});
				return loadingService.watch(apiAction);
			}
		);
	};

	async function openQuantityModal(title, uri) {
		const instance = $uibModal.open({
			component: "quantity-modal",
			size: "sm",
			backdrop: "static",
			resolve: {
				title: () => title,
				item: () => ctrl.inventoryItem
			}
		});

		const updated = await instance.result;

		const payload = {
			Quantity: updated.quantity
		};

		return await confirmAction(
			`You are about to ${title.toLowerCase()} of ${updated.quantity}, are you sure?`, 
			() => {
				const apiAction = api.post(uri, payload)
					.then(response => {
						toastr.success("Inventory has been successfully updated.");

						return response.Value;
					});
				return loadingService.watch(apiAction);
			}
		);
	}
}

export default angular
	.module("vesl.components.inventory-actions", [])
	.component("inventoryActions", {
		template,
		transclude: true,
		controller,
		bindings: {
			entity: "<",
			inventoryItem: "="
		}
	}).name;
